// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const appointmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAppointments: builder.query({
      query: (filters) => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `appointment/?${qs}`;
      },
      providesTags: ['Appointment', 'Session', 'Patient'],
    }),
    // DEPRECATED
    createAppointment: builder.mutation({
      query: body => ({
        url: 'appointment/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Appointment', 'Session', 'Patient', 'Availability'],
    }),
    // updateAppointment: builder.mutation({
    //   query: ({ id, body }) => ({
    //     url: `appointment/${id}/`,
    //     method: 'PUT',
    //     body: body,
    //   })
    // }),
    // removeAppointment: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `appointment/${id}/`,
    //     method: 'DELETE',
    //   }),
    //   invalidatesTags: ['Appointment', 'Session', 'Patient', 'Availability'],
    // }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAppointmentsQuery,
  useCreateAppointmentMutation,
  // useUpdateAppointmentMutation,
  // useRemoveAppointmentMutation
} = appointmentApi;
